class StickyTabs extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();

    this.selectors = {
      tabs: ".detail-tabs",
      tabItems: ".detail__tab-item",
      sections: ".section[data-id]",
    };
    this.stickyOffset = this.offsetTop;
  }

  stickElement() {
      if (window.pageYOffset > this.stickyOffset - this.headerHeight) {
        console.log(`[this.headerHeight] ${this.headerHeight}`);
        this.style.position = 'fixed';
        this.style.top = `${this.headerHeight}px`;
        this.style.width = '100%';
      } else {
        this.style.position = 'relative';
        this.style.top = `0px`;
        this.style.width = '100%';
      }
    }
  
  connectedCallback() {
    this.abortController = new AbortController();
    this.init();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  init() {
    this.tabItems = document.querySelectorAll(this.selectors.tabItems);
    this.sections = document.querySelectorAll(this.selectors.sections);
    
    // Add click listeners to tab items
    this.tabItems.forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    /*
    const headerIsSticky = document.querySelector('store-header[data-is-sticky="true"]');
    this.headerHeight = Number.parseInt(
      getComputedStyle(this.parentElement).getPropertyValue('--header-height').replace('px', ''),
      10
    );

    document.addEventListener("scroll", (event) => {
      this.stickElement();
    });
    */
  }


  handleTabClick(event) {
    const targetId = event.currentTarget.getAttribute("data-target");
    const targetElement = document.querySelector(`[data-id="${targetId}"]`)

    if (targetElement) {
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition;
      console.log(`[handleTabClick] ${offsetPosition}`);

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

     this.setActiveTab(targetId);
    }
  }


  setActiveTab(targetId) {
    this.tabItems.forEach((tab) => {
      tab.classList.remove("active");
    });

    const activeTab = Array.from(this.tabItems).find((tab) => {
      if (tab.getAttribute("data-target") === targetId) {
        return true;
      }
      return false;
    });
    if (activeTab) {
      activeTab.classList.add("active");
    }
  }
}

customElements.define("scroll-to-tabs", StickyTabs);
